var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Notifications',{ref:"notificationsMenu",attrs:{"data":_vm.notifications},on:{"onOpen":_vm.markUnreadNotificationsAsRead}})}
var staticRenderFns = []

export { render, staticRenderFns }